import { render } from "./tasksCreate.vue?vue&type=template&id=3ff6fff9&scoped=true"
import script from "./tasksCreate.vue?vue&type=script&lang=js"
export * from "./tasksCreate.vue?vue&type=script&lang=js"

import "./tasksCreate.vue?vue&type=style&index=0&id=3ff6fff9&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff6fff9"]])

export default __exports__